module.exports = __webpack_public_path__ + "static/media/InstagramIconMin.a1a4da2a.svg";